import React, { Suspense } from 'react';

// No spinner here on purpose. App.js warms every route chunk when the browser
// goes idle, so this fallback should almost never be seen — and when it is, an
// empty page-coloured shell reads as "still going" rather than as a flash of
// unrelated UI between two pages.
const LazyRoute = ({ children }) => (
  <Suspense fallback={<div className="min-h-[calc(100vh-var(--nav-h))] bg-[#0B0B0B]" aria-hidden="true" />}>
    {children}
  </Suspense>
);

export default LazyRoute;
